import ExcelFIleUpload from "../components/ExcelFIleUpload";


const ExcelPage = () => {
    return <div><ExcelFIleUpload/></div>;
};

export default ExcelPage;